<template>
    <div class="page-content">
        <h4 class="mt-n2 mb-4">
            Client Usage
        </h4>
        <div v-if="isAdminClient" class="d-flex">
            <!-- Client Dropdown -->

            <label class="input-hero me-3" style="width: 50%;">
                <span class="input-name">
                    Select Client:
                </span>
                <vue3-select style="width: 100%;" v-model="selectedPartner" :options="clientsList" label="label"
                    placeholder="Select an option" required class="mb-3" />
                <!--@update:modelValue="updateClientId()" -->
            </label>

            <!-- Excel button -->
            <div>
                <button class="excel-btn align-items-center justify-content-center" type="button"
                @click="showBasicConsolidateModal()">
                    <i class="fa-solid fa-file-excel fa-lg" style="color: #6571ff;"></i>
                </button>
            </div>
        </div>

        <!-- Date Picker Model -->
        <div class="modal fade" id="BasicConsolidateModal" tabindex="-1" aria-labelledby="DeactivatePartnerModalLabel"
            aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-kj-20 model-sm">
                <div class="modal-content border-radius-kj-20">
                    <div class="modal-header token-model-header-color">
                        <h5 class="modal-title text-centerm-auto" id="IncreaseTokenModalLabel">
                            <span class="font-size-20-kj">Basic Consolidated Data For All</span>
                        </h5>
                        <button type="button" id="close" class="btn-close" data-bs-dismiss="modal"
                            aria-label="btn-close" @click="resetModal()"></button>
                    </div>
                    <div class="modal-body ">
                        <div class="row mt-4">
                            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                <div class="form-check mb-4  " style="padding-left: 0px;">
                                    <label class="input-hero">
                                        <input type="date" class="form-control" id="start-time"
                                            v-model="this.BasicStartDate" :max="maxDateTime" />
                                        <span class="input-name">
                                            Candidate Creation From
                                            <span class="text-danger">*</span></span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                <div class="form-check mb-4" style="padding-left: 0px;">
                                    <label class="input-hero">
                                        <input type="date" class="form-control" id="end-time"
                                            v-model="this.BasicEndDate" :max="maxDateTime" />
                                        <span class="input-name">
                                            Candidate Creation To
                                            <span class="text-danger">*</span></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="text-end mt-3">
                            <button type="button" class="btn btn-primary btn-download" @click="generateExcelForBasic()"
                                :disabled="!this.BasicStartDate || !this.BasicEndDate">
                                Download Basic
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!isAdminClient">
            <!-- Month Year picker -->
            <div class="form-check mb-4" style="padding-left: 0px;">
                <label class="input-hero">
                    <input type="month" class="form-control" v-model="selectedMonthYear" :min="minMonthYear"
                        :max="maxMonthYear" />
                    <span class="input-name">
                        Select Month and Year
                        <span class="text-danger">*</span>
                    </span>
                </label>
            </div>
            <div class="text-end mt-3">
                <button type="button" class="btn btn-primary btn-download" @click="generateExcelForBasic()">
                    Download Basic
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import "vue3-select/dist/vue3-select.css";
import Vue3Select from "vue3-select";
import { mapActions, mapState } from "vuex";
import * as XLSX from 'xlsx';
import moment from 'moment';

export default {
    name: "ClientUsage",
    components: {
        Vue3Select,
    },
    data() {
        return {
            clientsList: [],
            selectedPartner: null,
            BasicStartDate: "",
            BasicEndDate: "",
            excelData: [],
            selectedClient: [],
            selectedMonthYear: null,
        }
    },
    async mounted() {
        this.ClientList();
    },
    methods: {
        ...mapActions(["GetClientsByInvoiceType", "postBasicConsolidatedDetails"]),
        async ClientList() {
            var clients = await this.GetClientsByInvoiceType();

            this.clientsList = clients?.object?.data?.map((i) => ({
                value: i.clientId,
                label: i.clientId + ' - ' + i.company,
            }));
        },
        showBasicConsolidateModal() {
            window.$('#BasicConsolidateModal').modal('show');
        },
        resetModal() {
            this.excelData = [];
            this.selectedClient = [];
            this.BasicStartDate = "";
            this.BasicEndDate = "";
        },
        async generateExcelForBasic() {
            const start = this.BasicStartDate;
            let endDate = this.BasicEndDate;
            if (this.user.clientId == 1001) {
                endDate = moment(endDate).add(1, 'days').format('YYYY-MM-DD');
            }
            let sendClientId = this.user.clientId
            if (this.selectedPartner != null) {
                sendClientId = this.selectedPartner.value;
            }
            var value = await this.postBasicConsolidatedDetails({
                clientId: sendClientId,
                fromDate: start,
                toDate: endDate
            });

            var newData = value.object?.data;
            newData.forEach((data) => {
                this.excelData.push({
                    ClientId: data.clientId,
                    ClientName: data.clientName || "NA",
                    TestId: data.testId || "NA",
                    TestName: data.testName || "NA",
                    CandidateID: data.candidateID,
                    CandidateName: data.candidateName || "NA",
                    EmailAddress: data.emailAddress || "NA",
                    Mobile: data.mobile || "NA",
                    TestStartTime: data.testStartTime || "NA",
                    TestEndTime: data.testEndTime || "NA",
                    Region: data.region || "NA",
                    OverallFitment: data.overallFitment || "NA",
                    AptitudeFitment: data.aptitudeFitment || "NA",
                    PsychometryFitment: data.psychometryFitment || "NA",
                });
            });
            if (this.excelData.length != 0) {
                const workbook = XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet(this.excelData);
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                XLSX.writeFile(workbook, 'BasicConsolidateSheet.xlsx');
                this.resetModal();
                window.$("#BasicConsolidateModal").modal("hide");
            }
        },
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
        isAdminClient() {
            return this.user.clientId === 1001;
        },
        currentDate() {
            return new Date(); // Current date for dynamic calculations
        },
        currentYear() {
            return this.currentDate.getFullYear(); // e.g., 2025
        },
        currentMonth() {
            return this.currentDate.getMonth(); // 0-based (e.g., 4 for May)
        },
        previousYear() {
            return this.currentYear - 1; // e.g., 2024 if current year is 2025
        },
        minMonthYear() {
            return `${this.previousYear}-01`; // e.g., "2024-01"
        },
        maxMonthYear() {
            let year = this.currentYear;
            let month = this.currentMonth;
            if (month === 0) { // January
                year -= 1;
                month = 11; // December of previous year
            } else {
                month -= 1; // Previous month
            }
            return `${year}-${String(month + 1).padStart(2, '0')}`; // e.g., "2025-04" in May 2025
        }
    },
    watch: {
        selectedMonthYear: {
            handler() {
                if (this.selectedMonthYear) {
                    //     // Split "YYYY-MM" into year and month
                    //     const [year, month] = this.selectedMonthYear.split('-').map(Number);
                    //     // Set start date to first day of selected month
                    //     this.BasicStartDate = `${year}-${String(month).padStart(2, '0')}-01`;
                    //     // Calculate end date (first day of next month)
                    //     let endYear = year;
                    //     let endMonth = month + 1;
                    //     if (endMonth > 12) {
                    //         endYear += 1;
                    //         endMonth = 1;
                    //     }
                    //     this.BasicEndDate = `${endYear}-${String(endMonth).padStart(2, '0')}-01`;
                    // }
                    const [year, month] = this.selectedMonthYear.split('-').map(Number);
                    const startDate = new Date(year, month - 1, 1);
                    const endDate = new Date(year, month, 1);
                    this.BasicStartDate = startDate.toISOString().split('T')[0];
                    this.BasicEndDate = endDate.toISOString().split('T')[0];
                }
            },
            immediate: true
        }
    }
}
</script>

<style scoped>
.excel-btn {
    width: 40px;
    height: 40px;
    background-color: white;
    border-radius: 50%;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: background-color 0.2s;
}

.excel-btn:hover {
    background-color: #f5f5f5;
}

.input-hero {
    display: block;
}
</style>